import FontAwesomeIcon from "components/FontAwesomeIcon/FontAwesomeIcon";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { pushToDataLayer } from "utils/gtm";

type Props = {
  colorScheme: "dark" | "light";
  setColorScheme: (darkMode: "dark" | "light") => void;
};

export const ColorSchemeToggle: FC<Props> = ({
  colorScheme,
  setColorScheme,
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    const nextScheme = colorScheme === "dark" ? "light" : "dark";
    pushToDataLayer({
      event: nextScheme === "light" ? "switch_mode_light" : "switch_mode_dark",
      screen_name: "theme toggle",
      journey_step: "theme toggle",
    });
    setColorScheme(nextScheme);
  };

  return (
    <div className="flex items-center gap-x-2.5">
      <div
        className={`-text--theme-colors-icon-brand-02 -bg--theme-colors-surface-neutral-level04 flex items-center justify-between h-7 w-[58px] rounded-full pe-[3px] ps-[2px] py-0.5 cursor-pointer`}
        onClick={handleClick}
      >
        {colorScheme === "light" && (
          <FontAwesomeIcon size="lg" name="fa-sun" className="p-1" />
        )}
        <div
          className={`h-6 w-6 rounded-full -bg--theme-colors-surface-brand-level00`}
        />
        {colorScheme === "dark" && (
          <FontAwesomeIcon size="lg" name="fa-moon" className="p-1" />
        )}
      </div>
    </div>
  );
};
